import { render } from "./You.vue?vue&type=template&id=1dee2743&scoped=true&ts=true"
import script from "./You.vue?vue&type=script&lang=ts"
export * from "./You.vue?vue&type=script&lang=ts"

import "./You.vue?vue&type=style&index=0&id=1dee2743&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dee2743"]])

export default __exports__